module.exports = __webpack_public_path__ + "img/TourobsLogo.f649814e.png";